import { frontendURL } from 'dashboard/helper/URLHelper';
import MediaLibraryView from './MediaLibraryView.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/media-library'),
    name: 'media_library',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
      featureFlag: 'media_library',
    },
    component: MediaLibraryView,
  },
];
